<template>
    <form-container v-if="dataObject" headerText="Spielberichteingabe" :buttonCancel="labelButtonCancel"
                    :button-ok="warningConfirmed?labelButtonOk:''" :realtimeSave="action==='editErgebnis'"
                    :width="1200" :action="action" :valid-actions="['editErgebnis', 'editErgebnisOnly', 'editErgebnisAdmin']"
                    @save="save()" :header-sub-text="subtitle" breakpoint="smAndDown"
                    :header-sub-text2="dataObject.infos.bahn + ', ' + dataObject.infos.ort"
                    :saved="saved" @close="saveAtCancel" :use-route="false">
        <spiel-bericht-edit-alert :warningConfirmed="warningConfirmed"
                                  :data-object="dataObject"
                                  @confirmed="confirmWarning">
        </spiel-bericht-edit-alert>
        <div v-if="warningConfirmed" class="tableContainer">
            <div class="mx-2 mb-3"  style="min-width: 1000px">
                <spiel-bericht-edit-result v-if="!dataObject.saison.isCup" :data-object="dataObject" :input="true"/>
                <spiel-bericht-edit-result-cup v-else :data-object="dataObject" :input="true"/>
            </div>
            <div v-if="rules" class="borderTop">
                <table style="min-width: 1016px">
                    <tr style="vertical-align: top">
                        <td class="pa-2">
                            <spiel-bericht-edit-ergebnis-team :data-object="dataObject" @scheduleSave="scheduleSave"
                                  type="heim" :rules="rules"></spiel-bericht-edit-ergebnis-team>
                        </td>
                        <td class="pa-2">
                            <spiel-bericht-edit-ergebnis-team :data-object="dataObject" @scheduleSave="scheduleSave"
                                  type="gast" :rules="rules"></spiel-bericht-edit-ergebnis-team>
                        </td>
                    </tr>
                </table>
            </div>
            <!--<v-btn @click="dataObject.setZufallResult()">Zufallsergebnis</v-btn>-->
            <div class="mx-2" style="min-width: 1000px">
                <v-textarea outlined v-model="dataObject.infos.kommentar"
                        label="Kommentar" class="mt-2 body-1" rows="3" hide-details
                        @input="scheduleSave()">
                </v-textarea>
                <v-row no-gutters>
                    <v-col>
                        <v-checkbox v-model="dataObject.heim.protest" @input="scheduleSave()"
                                hide-details class="pa-0 mb-3 d-inline-block"
                                label="Protest durch Heimverein"></v-checkbox>
                    </v-col>
                    <v-col>
                        <v-checkbox v-model="dataObject.gast.protest" @input="scheduleSave()"
                                hide-details class="pa-0 mb-3 d-inline-block"
                                label="Protest durch Gastverein"></v-checkbox>
                    </v-col>

                </v-row>

            </div>
        </div>
        <confirm-dialog :open="confirmSave.open" :header="confirmSave.header"
                        :question="confirmSave.question"
                        @reply="processConfirm" query-parameter="confirmSpielberichtSave">
            <p v-if="confirmSave.dataMissing" class="error--text mt-2">Achtung: Es sind nicht für alle Spieler
                und Durchgänge Wurfergebnisse eingetragen!
            </p>
        </confirm-dialog>
        <error-msg :error="error"></error-msg>
    </form-container>
</template>

<script>
    import FormContainer from "../../../../components/form/formContainer";
    import ErrorMsg from "../../../../components/elements/errorMsg";
    import {FormRules} from "../../../../services/formRules";
    import {Spiel} from "../../../../services/data/spiel";
    import SpielBerichtEditErgebnisTeam from "./spielBerichtEditErgebnisTeam";
    import SpielBerichtEditResult from "./spielBerichtEdit_result";
    import ConfirmDialog from "../../../../components/navigation/confirmDialog";
    import TimeStamp from "../../../../services/timeStamp";
    import SpielBerichtEditAlert from "./spielBerichtEditAlert";
    import SpielBerichtEditResultCup from "@/views/ergebnisdienst/spielbericht/edit/spielBerichtEdit_resultCup";

    export default {
        components: {
            SpielBerichtEditResultCup,
            SpielBerichtEditAlert,
            ConfirmDialog,
            SpielBerichtEditResult,
            SpielBerichtEditErgebnisTeam,
            ErrorMsg, FormContainer},
        name: "spiel-bericht-edit-ergebnis",
        props: ['currentData', 'action'],
        data: () => ({
            rules: null,
            dataObject: null,
            error: '',
            saved: false,
            savedTimeout: null,
            saveSchedule: null,
            confirmSave: {
                open: false,
                header: 'Spielbericht freigeben',
                question: '',
                item: null,
                dataMissing: false,
            },
            warningConfirmed: false,
        }),
        computed: {
            user(){ return this.$store.state.user; },
            subtitle(){ return this.dataObject.getSubTitle(); },
            labelButtonOk() { return this.action === 'editErgebnis' ?
                'Als Heimverein freigeben' : 'Speichern'},
            labelButtonCancel() { return this.action === 'editErgebnis' ? 'Schließen' : 'Abbrechen'},
        },
        created(){
            this.rules = new FormRules();
            this.dataObject = new Spiel();
            if ( this.currentData ) {
                this.dataObject.setFromDataObject(this.currentData);
            }
        },
        methods: {
        // multiuser alert
            confirmWarning(){
                this.warningConfirmed = true;
            },
        // others
            setSavedFlag(){
                this.saved = true;
                setTimeout(()=>{ this.saved = false; },4000)
            },
            scheduleSave(){
                if ( this.action === 'editErgebnis' ) {
                    clearTimeout(this.saveSchedule);
                    this.saveSchedule = setTimeout (
                        () => {
                            this.saveTemp(false);
                        },
                        5000,
                    )
                }
            },
            saveAtCancel(){
                if ( this.action === 'editErgebnis' ) {
                    clearTimeout(this.saveSchedule);
                    if ( this.dataObject.spielBerichtHasChanged(this.currentData) ) {
                        this.saveTemp(true);
                    } else {
                        window.history.back();
                    }
                } else {
                    window.history.back();
                }
            },
            async saveTemp(close){
            // create update document
                this.setDBDataObject();
            // save
                let reply = await this.dataObject.saveEdited('spiel_edit');
                if ( reply.successful ) {
                    this.setSavedFlag();
                    this.emitUpdatedSpiel();
                    if ( close ) { window.history.back() }
                } else {
                    this.error = this.dataObject.getDBErrorText(reply.content);
                }
            },
            save(){
                if ( this.action === 'editErgebnis' ) {
                    this.confirmSave.question = 'Möchtest du die Eingabe des Spielberichts wirklich' +
                        ' endgültig abschließen und den Spielbericht zur Bestätigung durch den' +
                        ' Gastverein freigeben?';
                    this.confirmSave.dataMissing = this.dataObject.hasEmptyDg();
                    this.confirmSave.open = true;
                } else {
                    this.saveFinal();
                }
            },
            processConfirm(reply) {
                if ( reply ) {
                    this.saveFinal();
                }
                this.confirmSave.dataMissing = false;
                this.confirmSave.open = false;
            },
            async saveFinal(){
                clearTimeout(this.saveSchedule);
            // create update document
                this.setDBDataObject();
                if ( this.action === 'editErgebnis' ) {
                    if ( this.dataObject.gast.vereinsNr.length === 4 ) {
                        // Dummy Verein, automatisch bestätigen
                        this.dataObject.local.documentUpdates['vereine.heim'] = this.dataObject.heim.vereinsNr + '_confirmed';
                        this.dataObject.local.documentUpdates['vereine.gast'] = this.dataObject.gast.vereinsNr + '_confirmed';
                        this.dataObject.local.documentUpdates['vereine.alle'] = [ this.dataObject.heim.vereinsNr ,
                                                                                  this.dataObject.gast.vereinsNr ];
                        if ( !this.dataObject.vereine.confirmedHeim ) {
                            this.dataObject.local.documentUpdates['vereine.confirmedHeim'] = TimeStamp.getGMTTimestamp();
                            this.dataObject.local.documentUpdates['vereine.confirmedGast'] = TimeStamp.getGMTTimestamp();
                            this.dataObject.local.documentUpdates['vereine.confirmedHeimBy'] = this.user.email;
                            this.dataObject.local.documentUpdates['vereine.confirmedGastBy'] = this.user.email;
                        }
                        /*this.dataObject.local.documentUpdates.vereine = {
                            heim: this.dataObject.heim.vereinsNr + '_confirmed',
                            gast: this.dataObject.gast.vereinsNr + '_confirmed',
                            alle: [ this.dataObject.heim.vereinsNr ,
                                this.dataObject.gast.vereinsNr ],
                            confirmedHeim: TimeStamp.getGMTTimestamp(),
                            confirmedGast: TimeStamp.getGMTTimestamp(),
                            confirmedHeimBy: this.user.email,
                            confirmedGastBy: this.user.email,
                            //confirmDeadline: TimeStamp.getGMTTimestamp() + 48*60*60*1000,
                        };*/
                    } else {
                        // regulärer Verein
                        this.dataObject.local.documentUpdates['vereine.heim'] = this.dataObject.heim.vereinsNr + '_created';
                        this.dataObject.local.documentUpdates['vereine.gast'] = this.dataObject.gast.vereinsNr + '_waiting';
                        this.dataObject.local.documentUpdates['vereine.alle'] = [];
                        if ( !this.dataObject.vereine.confirmedHeim ) {
                            this.dataObject.local.documentUpdates['vereine.confirmedHeim'] = TimeStamp.getGMTTimestamp();
                            this.dataObject.local.documentUpdates['vereine.confirmedGast'] = null;
                            this.dataObject.local.documentUpdates['vereine.confirmedHeimBy'] = this.user.email;
                            this.dataObject.local.documentUpdates['vereine.confirmedGastBy'] = '';
                        }
                        /*this.dataObject.local.documentUpdates.vereine = {
                            heim: this.dataObject.heim.vereinsNr + '_created',
                            gast: this.dataObject.gast.vereinsNr + '_waiting',
                            alle: [],
                            confirmedHeim: TimeStamp.getGMTTimestamp(),
                            confirmedGast: null,
                            confirmedHeimBy: this.user.email,
                            confirmedGastBy: '',
                            //confirmDeadline: TimeStamp.getGMTTimestamp() + 48*60*60*1000,
                        };*/
                    }
                }
            // save
                this.$store.state.local.loader = true;
                let reply = await this.dataObject.saveEdited('spiel_edit');
                if ( reply.successful ) {
                    this.emitUpdatedSpiel();
                    window.history.back();
                } else {
                    this.error = this.dataObject.getDBErrorText(reply.content);
                }
                this.$store.state.local.loader = false;
            },
                emitUpdatedSpiel(){
                    if ( this.action === 'editErgebnis' ) {
                    // return pure data object
                        let spiel = this.dataObject.getDbObject();
                        spiel.id = this.dataObject.id;
                        if ( this.dataObject.local.documentUpdates['vereine.heim'] ) {
                            spiel.vereine.heim = this.dataObject.local.documentUpdates['vereine.heim'];
                            spiel.vereine.gast = this.dataObject.local.documentUpdates['vereine.gast'];
                            spiel.heim = this.dataObject.heim;
                            spiel.gast = this.dataObject.gast;
                        }
                        this.$emit('updated', spiel);
                    }
                },
                setDBDataObject(){
                    this.dataObject.local.documentUpdates = {
                        gast: this.dataObject.gast,
                        heim: this.dataObject.heim,
                        partien: this.dataObject.partien,
                        ['infos.kommentar']: this.dataObject.infos.kommentar,
                    };
                }
        },
        watch: {
            'dataObject.heim.protest'(){
                this.scheduleSave();
            }
        }
    }
</script>

<style scoped>
    .tableContainer { width: 100%; overflow-x: auto;overflow-y: hidden;}
    .borderTop {border-top: solid 1px lightgrey;}
</style>